// extracted by mini-css-extract-plugin
export default {"Prod_div":"Books_Prod_div__s0wBY","innerDiv":"Books_innerDiv__u+qC6","SideBar":"Books_SideBar__1u01q","allProduct_div":"Books_allProduct_div__EfbiT"};